import { createSlice } from '@reduxjs/toolkit';
import { REHYDRATE } from 'redux-persist';
import { toneColors } from 'config/constants';
const initialState = {
  charColors: true,
  pinyinColors: true,
  globalDash: true,
  lightFirstTone: toneColors.lightFirstTone,
  lightSecondTone: toneColors.lightSecondTone,
  lightThirdTone: toneColors.lightThirdTone,
  lightFourthTone: toneColors.lightFourthTone,
  lightFifthTone: toneColors.lightFifthTone,
  darkFirstTone: toneColors.darkFirstTone,
  darkSecondTone: toneColors.darkSecondTone,
  darkThirdTone: toneColors.darkThirdTone,
  darkFourthTone: toneColors.darkFourthTone,
  darkFifthTone: toneColors.darkFifthTone
};
const ensureColorDefaults = state => {
  const defaults = {
    lightFirstTone: toneColors.lightFirstTone,
    lightSecondTone: toneColors.lightSecondTone,
    lightThirdTone: toneColors.lightThirdTone,
    lightFourthTone: toneColors.lightFourthTone,
    lightFifthTone: toneColors.lightFifthTone,
    darkFirstTone: toneColors.darkFirstTone,
    darkSecondTone: toneColors.darkSecondTone,
    darkThirdTone: toneColors.darkThirdTone,
    darkFourthTone: toneColors.darkFourthTone,
    darkFifthTone: toneColors.darkFifthTone
  };
  return {
    ...defaults,
    ...state
  };
};
const colorSettingsSlice = createSlice({
  name: 'colorSettings',
  initialState,
  reducers: {
    setColorSettings: (state, action) => {
      return {
        ...state,
        ...action.payload
      };
    },
    toggleCharColors: state => {
      state.charColors = !state.charColors;
    },
    togglePinyinColors: state => {
      state.pinyinColors = !state.pinyinColors;
    },
    toggleGlobalDash: state => {
      state.globalDash = !state.globalDash;
    },
    setToneColor: (state, action) => {
      const {
        tone,
        mode,
        color
      } = action.payload;
      if (mode === 'light') {
        state[`light${tone}Tone`] = color;
      } else {
        state[`dark${tone}Tone`] = color;
      }
    },
    resetColorSettings: () => initialState
  },
  extraReducers: builder => {
    builder.addCase(REHYDRATE, (state, action) => {
      if (action.payload?.colorsettings) {
        return ensureColorDefaults(action.payload.colorsettings);
      }
      return ensureColorDefaults(state);
    }).addCase('settingsSyncSuccess', (state, action) => {
      if (action.payload) {
        const {
          charColors,
          pinyinColors,
          globalDash,
          lightFirstTone,
          lightSecondTone,
          lightThirdTone,
          lightFourthTone,
          lightFifthTone,
          darkFirstTone,
          darkSecondTone,
          darkThirdTone,
          darkFourthTone,
          darkFifthTone
        } = action.payload;
        const updatedState = {
          ...state,
          ...(charColors !== undefined && {
            charColors
          }),
          ...(pinyinColors !== undefined && {
            pinyinColors
          }),
          ...(globalDash !== undefined && {
            globalDash
          }),
          ...(lightFirstTone !== undefined && {
            lightFirstTone
          }),
          ...(lightSecondTone !== undefined && {
            lightSecondTone
          }),
          ...(lightThirdTone !== undefined && {
            lightThirdTone
          }),
          ...(lightFourthTone !== undefined && {
            lightFourthTone
          }),
          ...(lightFifthTone !== undefined && {
            lightFifthTone
          }),
          ...(darkFirstTone !== undefined && {
            darkFirstTone
          }),
          ...(darkSecondTone !== undefined && {
            darkSecondTone
          }),
          ...(darkThirdTone !== undefined && {
            darkThirdTone
          }),
          ...(darkFourthTone !== undefined && {
            darkFourthTone
          }),
          ...(darkFifthTone !== undefined && {
            darkFifthTone
          })
        };
        return ensureColorDefaults(updatedState);
      }
      return state;
    });
  }
});
export const {
  setColorSettings,
  toggleCharColors,
  togglePinyinColors,
  toggleGlobalDash,
  setToneColor,
  resetColorSettings
} = colorSettingsSlice.actions;
export default colorSettingsSlice.reducer;